import { ResetPasswordPage } from "@shared/features/auth/pages/ResetPasswordPage";
import {
  PLATFORM_RESET,
  usePlatformDispatch,
} from "@platform//PlatformContext";
import { useClosePlatformAccess } from "@platform/hooks/useClosePlatformAccess";

export function PlatformResetPasswordPage() {
  useClosePlatformAccess();
  
  const dispatch = usePlatformDispatch();

  const onError = () => {
    dispatch({ type: PLATFORM_RESET });
  };

  return <ResetPasswordPage onError={onError} />;
}

export default PlatformResetPasswordPage;
